// auto-generated by Typewriter template _models.tst from PortCall.Core.EndPoints\Api\UserRole\ApiUserRole.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Role, RoleData, RoleOptions } from 'data/models/Role';
import { User, UserData, UserOptions } from 'data/models/User';

// UserRoleData is the class that UserRole serializes to/from
export interface UserRoleData {
    RoleId : number;
    Url : string | null;
    UserId : number;
	
    Role : RoleData | null;
    User : UserData | null;
	
}

// UserRoleOptions is the class which may be passed to the UserRole constructor to define optional initial data values
export interface UserRoleOptions {
    RoleId : number;
    Url? : string | null;
    UserId : number;
	
    Role? : RoleOptions | null;
    User? : UserOptions | null;
	
}

export class UserRole {
    public RoleId : DataSignal<number>;
    public Url : DataSignal<string | null>;
    public UserId : DataSignal<number>;
	
    public Role : DataSignal<Role | null>;
    public User : DataSignal<User | null>;
	

    constructor();
    constructor(data : UserRoleOptions);
    constructor(data: UserRoleOptions | null = null) {
        this.RoleId = jsonableObservable(S.value<number>(data && data.RoleId !== undefined ? data.RoleId : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
        this.UserId = jsonableObservable(S.value<number>(data && data.UserId !== undefined ? data.UserId : 0));
	    
        this.Role = S.value<Role | null>(null);
        this.User = S.value<User | null>(null);
	    
    }

    static key(obj : UserRole) {
        return obj.RoleId() + '\u2618' + obj.UserId();
    }
    
    static dataKey(obj : UserRoleOptions) {
        return obj.RoleId + '\u2618' + obj.UserId;
    }

    static update(obj : UserRole, data : UserRoleOptions) {
        S.freeze(() => {
            if (data.RoleId !== undefined) obj.RoleId(data.RoleId);
            if (data.Url !== undefined) obj.Url(data.Url);
            if (data.UserId !== undefined) obj.UserId(data.UserId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/UserRole.ts